import React from "react";
import classNames from "classnames";
import { HeaderBullet } from "@ugg/shared/components/common/HeaderBullet";
import { useChampionProfileContext } from "@ugg/shared/components/Champions/ChampionProfileContext";
import { QueueTypeS, getQueueTypeName } from "@ugg/shared/utils/queue-type-helpers";
import { ChampionBalance } from "@ugg/shared/interfaces/champions/queue-type-balances.interface";
import { filterModStats } from "@ugg/shared/utils/champion-modification-helpers";
import { ChampionSkill } from "@outplayed/tooltips";

interface AdditionalStatsProps {
  className?: string;
  queueType: string;
  championModifications: ChampionBalance | undefined | null;
}

const AdditionalStats = (props: AdditionalStatsProps) => {
  const { className, queueType, championModifications } = props;
  const { championId, championData } = useChampionProfileContext();
  const queueTypeName = getQueueTypeName(queueType);
  const championName = championData?.name || "";

  if (!championModifications) {
    return null;
  }

  const getLolWikiURL = () => {
    return queueType === QueueTypeS.ARURF || queueType === QueueTypeS.PICK_URF
      ? "https://leagueoflegends.fandom.com/wiki/Ultra_Rapid_Fire"
      : "https://leagueoflegends.fandom.com/wiki/ARAM";
  };

  const { damageDealt, championChanges, abilityChanges } = filterModStats(
    championModifications,
    championId,
    championData || undefined,
  );
  return (
    <div className={classNames("additional-stats flex flex-col bg-purple-400 rounded-[3px] p-[18px]", className)}>
      <HeaderBullet>
        {championName} {queueTypeName} Modifications
      </HeaderBullet>
      <div className="main-content flex flex-1 mt-[18px] text-[14px] text-[#bbbedb] font-bold font-['Inter'] overflow-auto">
        <ul className="list flex-1 flex flex-col p-0 m-0 list-disc font-extralight">
          {[...damageDealt, ...championChanges].map((modification, idx) => {
            return (
              <div className="entireChange" key={idx}>
                <div className="bullet"></div>
                {modification}
              </div>
            );
          })}
          {abilityChanges.map((modification, idx) => {
            return (
              <div className="entireChange" key={idx}>
                {modification}
              </div>
            );
          })}
          <div className="pt-[12px] mt-auto font-light text-[14px] leading-[20px] text-lavender-300">
            Stats collected from{" "}
            <a target="_blank" className="text-lavender-300 underline" href={getLolWikiURL()}>
              here
            </a>
          </div>
        </ul>
      </div>
    </div>
  );
};

export default AdditionalStats;
